import React from "react";
import LoaderIcon from "../../assets/Loader/Loader.svg";
import styles from './Loader.module.css';

export default function Loader() {
  return (
    <div className={styles.loaderContainer}>
        
      <img 
        src={LoaderIcon} 
        alt="Loader" 
        className={styles.loaderIcon}
      />
    </div>  
  );
}